import {
  Edit,
  SimpleForm,
  BooleanInput,
  NumberInput,
  SelectInput,
  TextInput,
  required,
  useRecordContext
} from 'react-admin';
import { useWatch } from 'react-hook-form';
import { Typography } from '@mui/material';
import { BackButton } from '../../../helperComponents/BackButton';
import { AdsJobsToolbar } from './components/AdsJobsToolbar';
import { windowDays, priority, runAfterHour } from '../../../../helpers/adsJobsValidators';
import {
  ADS_JOB_SCHEDULES,
  ADS_JOB_ONCE_NOTE,
  ADS_JOB_LEGACY_WINDOW_WARN_ABOVE,
  ADS_JOB_LEGACY_WINDOW_WARNING,
  ADS_JOB_REPLACE_WINDOW_NOTE
} from '../../../../helpers/adsJobsConstants';

const EDITABLE_FIELDS = [
  'id',
  'schedule',
  'run_after_utc_hour',
  'priority',
  'enabled',
  'window_days',
  'replace_window'
];

// config, name, type and the joined fields never go in the body
const pickEditable = (data) => {
  const picked = EDITABLE_FIELDS.reduce((acc, field) => (field in data ? { ...acc, [field]: data[field] } : acc), {});
  // the switch is only rendered for switchable jobs; never send its value for the others
  if (data.replace_window_available !== true) delete picked.replace_window;
  return picked;
};

const WindowInput = () => {
  const record = useRecordContext();
  const windowValue = useWatch({ name: 'window_days' });

  if (!record || record.snapshot === true) return null;

  const showWarning = record.type === 'legacy_csv' && Number(windowValue) > ADS_JOB_LEGACY_WINDOW_WARN_ABOVE;

  return (
    <>
      <NumberInput source="window_days" label="Window (days)" validate={windowDays} />
      {showWarning && (
        <Typography color="warning.main" variant="caption">{ADS_JOB_LEGACY_WINDOW_WARNING}</Typography>
      )}
    </>
  );
};

const ReplaceWindowInput = () => {
  const record = useRecordContext();

  if (!record || record.replace_window_available !== true) return null;

  return <BooleanInput source="replace_window" label="Replace window" helperText={ADS_JOB_REPLACE_WINDOW_NOTE} />;
};

export const AdsJobsEdit = (props) => {
  return (
    <>
      <BackButton path="/ads_jobs" />
      <span className="h4">Edit Job</span>
      <Edit {...props} title=" " redirect="list" mutationMode="pessimistic" transform={pickEditable}>
        <SimpleForm toolbar={<AdsJobsToolbar />}>
          <TextInput source="id" label="ID" disabled />
          <TextInput source="name" label="Name" disabled />
          <TextInput source="type" label="Type" disabled />
          <TextInput source="target" label="Target" disabled />
          <SelectInput
            source="schedule"
            label="Schedule"
            choices={ADS_JOB_SCHEDULES}
            validate={required()}
            helperText={ADS_JOB_ONCE_NOTE}
          />
          <NumberInput
            source="run_after_utc_hour"
            label="Run after (UTC hour)"
            validate={runAfterHour}
            parse={(value) => (value === '' || value === null || Number.isNaN(value) ? null : value)}
          />
          <WindowInput />
          <ReplaceWindowInput />
          <NumberInput source="priority" label="Priority" validate={priority} />
          <BooleanInput source="enabled" label="Enabled" />
        </SimpleForm>
      </Edit>
    </>
  );
};
